import { Button } from "@twilio-paste/core/button"
import log from "loglevel";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getConversationDetail } from "../sessionDataHandler";
import { getQualtricsSurveyEnabledQueues } from "../store/actions/taskActions";
import { AppState } from "../store/definitions";



export const QualtricsSurvey = () => {
    const [qualtricsSurveyUrl, setQualtricsSurveyUrl] = useState<string>("");

    const { lastQueueId, lastQueueName, qualtricsSurveyConfig } = useSelector((state: AppState) => ({
        lastQueueId: state.session.lastQueueId || "",
        lastQueueName: state.session.lastQueueName || "",
        qualtricsSurveyConfig: state.config.qualtricsSurvey
    }));

    useEffect(() => {

        //Show survey feedback link only when it is enabled in client config
        if (qualtricsSurveyConfig?.enabled) {
            const conversationDetails = getConversationDetail()
            //Show survey feedback link only when there is an agent participated in the chat
            if (conversationDetails && conversationDetails.AgentName) {
                getQualtricsSurveyEnabledQueues()
                    .then(async (response) => response.json())
                    .then((result) => {
                        if (result?.Data) {
                            const matchingQueue = result?.Data.find((q: { QueueID: string; SurveyID: string; IsActive: boolean; }) => q.QueueID === lastQueueId && q.IsActive === true);
                            //Find out last chatted queue has survey id linked or not
                            if (matchingQueue && matchingQueue?.SurveyID) {
                                const qualtricsSurveyBaseUrl = process.env.REACT_APP_QUALTRICS_SURVEY_BASE_URL
                                if (qualtricsSurveyBaseUrl) {
                                    //Setup feedback survey URL
                                    const data = {
                                        CustomerName: conversationDetails.friendlyname,
                                        Queue: lastQueueName,
                                        AgentSMID: conversationDetails.AgentSmid,
                                        AgentFirstName: conversationDetails.AgentName,
                                        CustomerPhone: conversationDetails.phonenumber
                                    }
                                    const jsonString = JSON.stringify(data);
                                    const encodedString = btoa(jsonString);
                                    const surveyUrl: string = qualtricsSurveyBaseUrl.concat(matchingQueue?.SurveyID, "?Q_EED=", encodedString);
                                    setQualtricsSurveyUrl(surveyUrl)
                                }
                            }
                        }
                    })
                    .catch(err => {
                        log.error(err);
                    });
            }
        }
    }, []);

    return (
        <>
            {qualtricsSurveyUrl?.length > 0 && 
            <div>
                <style>
                {`
                    [data-paste-element="FEEDBACK_BTN"] {
                        background-color: #0263e0 !important;
                        color: white !important;
                    }
                `}
                </style>
                <p>We value your feedback. Please take a moment to share your experience.</p>
                <Button element="FEEDBACK_BTN" variant="primary" as="a" href={qualtricsSurveyUrl} target="_blank">Take Feedback Survey</Button>
             </div>
            }
        </>
    );
};